import Logger from '../../libs/logger'
import cardStore from './store/card-store'
if(!window.log) {
  window.log = new Logger({
    level: 4,
    usePrefix: false,
    colorized: true,
  });
}
export default {
  created() {
    this.$log = window.log
    this.$cardStore = cardStore
  },
  methods: {
    pascalCase(s) {
      return s.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    formatText(s, format = null) {
      switch(format) {
        case 'pascal':
          return this.pascalCase(s)
        default:
          return s
      }
    }
  }
};